import {atom} from "recoil";


export const token_state = atom<string>({
    key: 'token_state',
    default: ""
})

export interface sms_trx_state_props {
    txSeqNo?: string;
    resendCnt?: string;
    expiresAt?: Date | null;
}

export const sms_trx_state = atom<sms_trx_state_props>({
    key: 'trx_state',
    default: {}
})

export interface acnt_trx_state_props {
    mchtTrdNo?: string;
    bankChkYn?: string;
    expiresAt?: Date;
}


export const acnt_trx_state = atom<acnt_trx_state_props>({
    key: 'bank_trx_state',
    default: {}
})